//@ts-ignore
import { FormLayout } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import CreateIcon from "../../Icons/CreateIcon";
import {
  createCategorySchema,
  ICategorySchema,
} from "../../utils/validationSchema";
import CreateCategory from "./CategoryForm";

export interface ICreateCategoryData {
  name: string;
  description: string;
  previewImage: File | null;
}

const CreateBlog = (props: any) => {
  const { isLoading, handleCreate } = props;

  const {
    register,
    handleSubmit,
    getValues,
    setError,
    setValue,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<ICategorySchema>({
    defaultValues: async () => ({
      name: "",
      preview_image: null,
      description: "",
    }),
    resolver: yupResolver(createCategorySchema),
  });

  return (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Category
        </span>
      </div>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        <CreateCategory
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          control={control}
        />
      </FormLayout>
    </div>
  );
};

export default CreateBlog;
